import React from 'react';
import { ItemList } from 'components/item-list/ItemList';
import { ItemListItem } from 'components/item-list/ItemListItem';
import { Divider } from 'components/elements/divider/Divider';

export const Component = () => {
  return (
    <>
      <Divider>Item list</Divider>

      <ItemList
        title="Item list title"
        text={
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam id malesuada libero.
            Sed in massa in leo ornare molestie ac eget libero. Pellentesque lectus sapien, interdum
            a tincidunt non, euismod a est. Nunc laoreet malesuada mauris.
          </p>
        }
        isSlice
      >
        <ItemListItem
          index={1}
          title="List item title"
          text={
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam id malesuada libero.
              Sed in massa in leo ornare molestie ac eget libero.
            </p>
          }
          numbered={false}
        />
        <ItemListItem
          index={2}
          title="List item title"
          text={
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam id malesuada libero.
              Sed in massa in leo ornare molestie ac eget libero.
            </p>
          }
          numbered={false}
        />
        <ItemListItem
          index={3}
          title="List item title"
          text={
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam id malesuada libero.
              Sed in massa in leo ornare molestie ac eget libero.
            </p>
          }
          numbered={false}
        />
        <ItemListItem
          index={4}
          title="List item title"
          text={
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam id malesuada libero.
              Sed in massa in leo ornare molestie ac eget libero.
            </p>
          }
          numbered={false}
        />
        <ItemListItem
          index={5}
          title="List item title"
          text={
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam id malesuada libero.
              Sed in massa in leo ornare molestie ac eget libero.
            </p>
          }
          numbered={false}
        />
        <ItemListItem
          index={6}
          title="List item title"
          text={
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam id malesuada libero.
              Sed in massa in leo ornare molestie ac eget libero.
            </p>
          }
          numbered={false}
        />
      </ItemList>

      <Divider>Numbered item list</Divider>

      <ItemList
        title="Numbered list title"
        text={
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam id malesuada libero.
            Sed in massa in leo ornare molestie ac eget libero. Pellentesque lectus sapien, interdum
            a tincidunt non, euismod a est. Nunc laoreet malesuada mauris.
          </p>
        }
        isSlice
      >
        <ItemListItem
          index={1}
          title="List item title"
          text={
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam id malesuada libero.
              Sed in massa in leo ornare molestie ac eget libero.
            </p>
          }
        />
        <ItemListItem
          index={2}
          title="List item title"
          text={
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam id malesuada libero.
              Sed in massa in leo ornare molestie ac eget libero.
            </p>
          }
        />
        <ItemListItem
          index={3}
          title="List item title"
          text={
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam id malesuada libero.
              Sed in massa in leo ornare molestie ac eget libero.
            </p>
          }
        />
        <ItemListItem
          index={4}
          title="List item title"
          text={
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam id malesuada libero.
              Sed in massa in leo ornare molestie ac eget libero.
            </p>
          }
        />
        <ItemListItem
          index={5}
          title="List item title"
          text={
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam id malesuada libero.
              Sed in massa in leo ornare molestie ac eget libero.
            </p>
          }
        />
        <ItemListItem
          index={6}
          title="List item title"
          text={
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam id malesuada libero.
              Sed in massa in leo ornare molestie ac eget libero.
            </p>
          }
        />
      </ItemList>
    </>
  );
};
